import { inject, Injectable, Injector, TransferState } from '@angular/core';
import {
    HttpInterceptor,
    HttpHandler,
    HttpEvent,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { filter, map, Observable } from 'rxjs';

import { LocaleService } from '@finder/shared/services/locale-service/locale-service.service';
import { LOCALE, LOCALE_DEFAULT, SSR_LOCALE } from '@finder/shared/constants/app.constants';

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
    private ssrLocale = inject(LOCALE, { optional: true });

    constructor(
        private injector: Injector,
        private transferState: TransferState,
    ) { }

    /**
     * Add the locale to every request
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const localeService = this.injector.get(LocaleService);

        // Get locale from cookie, and if it's not defined, use the default
        const locale = this.ssrLocale || localeService.getLocale() || LOCALE_DEFAULT;

        let headers: any = {
            setHeaders: {
                'Accept-Language': locale
            },
        };

        req = req.clone(headers);

        /**
         * For some reason akamai will return the english canadian locale as en-ca. This is corrected
         * in the API and needs to be captured once it's returned and stored so the rest of the
         * locale code can access the right data.
         *
         * This will catch the response from the API and I can use it to store the correct locale
         */
        return next.handle(req).pipe(
            filter(event => event instanceof HttpResponse),
            map((response: HttpResponse<any>) => {
                // check for SSR and set a new locale
                if (this.ssrLocale && response?.body?.locales?.locale) {
                    this.transferState.set(SSR_LOCALE, response.body.locales.locale);
                }

                return response;
            })
        );
    }
}
